import React, { FunctionComponent } from 'react';
import { Menu, Icon } from 'semantic-ui-react';
import { useQuery } from 'react-apollo';
import withStyles from 'react-jss';

import { useUserMgmt } from 'components/UserMgmt/UserMgmt.context';
import { GET_PROFILE } from 'components/UserMgmt/UserMgmt.queries';

import styles from './SecondaryNav.styles';

import ExternalSubNav from './components/ExternalSubNav';
import InternalSubNav from './components/InternalSubNav';
import ShowLogout from './components/ShowLogout';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

const SecondaryNav: FunctionComponent<Props> = ({ classes }) => {
  const { isInternalUser, isExternalUser } = useUserMgmt();

  const { loading, data } = useQuery(GET_PROFILE);

  if (loading) {
    return (
      <Menu className={classes.subMenu}>
        <Icon name="spinner" loading />
      </Menu>
    );
  }

  const { userProfile } = data;

  return (
    <Menu className={classes.subMenu}>
      {isExternalUser && <ExternalSubNav profile={userProfile} />}
      {isInternalUser && <InternalSubNav profile={userProfile} />}
      {!isExternalUser && !isInternalUser && <ShowLogout />}
    </Menu>
  );
};

export default withStyles(styles)(SecondaryNav);
